import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Wrapper,
  BoxSkeleton,
  LeftContent,
  RightContent
} from './ShimmerRevampedCurrencyCalculator.styles';
import { skeletonProps } from '../Shimmer.types';

const CurrencyBoxSkeleton = () => (
  <BoxSkeleton>
    <LeftContent>
      <Skeleton width={60} height={14} borderRadius={4} {...skeletonProps} />
      <Skeleton width={120} height={28} borderRadius={4} {...skeletonProps} />
    </LeftContent>
    <RightContent>
      <Skeleton circle width={24} height={24} {...skeletonProps} />
      <Skeleton width={52} height={22} borderRadius={4} {...skeletonProps} />
      <Skeleton width={14} height={14} borderRadius={2} {...skeletonProps} />
    </RightContent>
  </BoxSkeleton>
);

export const ShimmerRevampedCurrencyCalculator = () => {
  return (
    <Wrapper>
      <CurrencyBoxSkeleton />
      <CurrencyBoxSkeleton />
      <Skeleton
        height={48}
        borderRadius={50}
        className="convert-btn-skeleton"
        {...skeletonProps}
      />
    </Wrapper>
  );
};
